import { differenceInYears, isValid } from "date-fns";
import type { PassengerCategory } from "./getLeadGuest";

/** Passenger type codes shared by Deutsche Bahn, ÖBB and Airport Bus. */
const PASSENGER_CATEGORY_BY_TYPE_CODE: Record<string, PassengerCategory> = {
  PNOS: "adult",
  PSOE: "adult",
  PYPO: "youth",
  PCIL: "child",
  PINT: "infant"
};

export const ADULT_MIN_AGE = 18;
export const INFANT_MAX_AGE_EXCLUSIVE = 6;

/** Category of a passenger type code (e.g. `PNOS`), or `undefined` for an unknown code. */
export const getPassengerCategoryByTypeCode = (typeCode: string | null | undefined): PassengerCategory | undefined =>
  typeCode ? PASSENGER_CATEGORY_BY_TYPE_CODE[typeCode] : undefined;

/**
 * Category from the passenger's age on the travel date. Uses today when the travel date is missing or invalid.
 * Returns `undefined` for a missing or invalid birth date.
 */
export const getPassengerCategoryByBirthDate = (
  birthDate: Date | string | null | undefined,
  travelDate?: Date | null
): PassengerCategory | undefined => {
  if (!birthDate) {
    return undefined;
  }

  const birth = birthDate instanceof Date ? birthDate : new Date(birthDate);

  if (!isValid(birth)) {
    return undefined;
  }

  const referenceDate = travelDate && isValid(travelDate) ? travelDate : new Date();
  const age = differenceInYears(referenceDate, birth);

  if (age >= ADULT_MIN_AGE) {
    return "adult";
  }

  return age < INFANT_MAX_AGE_EXCLUSIVE ? "infant" : "child";
};
